export const BLUE_TRIANGLE_TYPE_NAVIGATION = 'navigation' as string;

export const FB_SUBSCRIPTION_COMPLETE_ROUTE = 'subscription-complete';
export const FB_MTPD = 'MTPD';

export const B2C = 'DIY';
export const B2B = 'PRO';

export const GA4_AUTH_EVENTS = {
	LOGIN_COMPLETE: 'login_complete',
	CREATE_ACCOUNT_COMPLETE: 'create_account_complete',
	PASSWORD_RECOVERED: 'password_recovered',
} as const;

export const GA4_PAYMENT_TYPES = {
	CREDIT_CARD: 'TDC',
	PAY_IN_STORE: 'PayInStore',
	OPENPAY: 'OpenPay',
	OXXO: 'Oxxo',
	PAYPAL: 'PayPal',
	GIFTCARD: 'GiftCard',
} as const;

export const PREV_URL_SESSION_STORAGE_KEY = 'prev_url_value';
export const CURR_URL_SESSION_STORAGE_KEY = 'curr_url_value';

export const PINTEREST_DELIVERY_CATEGORIES = {
	PICK_UP_IN_STORE: 'pick_at_store',
	MAIL: 'home_delivery',
} as const;

export const FACEBOOK_DELIVERY_CATEGORIES = {
	IN_STORE: 'in_store',
	HOME_DELIVERY: 'home_delivery',
} as const;

export const MULTI_FREE_GIFT_PROMO = 'MULTI_FREE_GIFT' as const;
export const ADJUSTMENTS_COMBO_PROMO = 'Combo' as const;

export const GIFT_TYPE = {
	TRIGGER: 'trigger',
	GIFT: 'gift',
} as const;

export type GiftType = (typeof GIFT_TYPE)[keyof typeof GIFT_TYPE];

export const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;

export const ITEM_DELIVERY_METHODS = {
	HOME_DELIVERY: 'home_delivery',
	BOPIS: 'BOPIS',
} as const;

export const SAME_DAY_DELIVERY_DAYS = '0';
